import { VInitRequest, VisaService, VPanEnroll, VPurchaseRequest } from "@/services/visa";
import { Button, Grid, Input } from "@mantine/core";
import { randomUUID } from "crypto";
import { useEffect, useRef, useState } from "react";

export function VTSEnrole() {
    let dfpSessionId: string = "";
    let requestId: string = "";
    useEffect(() => {
        console.log("initialize VTS");
        window.addEventListener(
            "message",
            async (event: MessageEvent) => {
                console.log("VTS frame data: ", event.data);
                if (!event.data) {
                    return;
                } else {
                    try {
                        //const resp = JSON.parse(event.data);
                        if (event.data.requestID && event.data.type === "AUTH_READY") {
                            console.log("init with requestID", event.data.requestID, frame);
                            const authSessionRequest = {
                                requestID: event.data.requestID,
                                type: "CREATE_AUTH_SESSION",
                                version: "1",
                                contentType: "application/json"
                            };
                            if (vtsFrameRef) {
                                console.log("send auth session:  ", authSessionRequest)
                                vtsFrameRef.current?.contentWindow?.postMessage(JSON.stringify(authSessionRequest), vtsFidoUrl);
                            }
                        } else if (event.data.type === "AUTH_SESSION_CREATED") {
                            // get sessionContxt
                            requestId = window.crypto.randomUUID()
                            dfpSessionId = event.data.dfpSessionID
                            const vreq: VInitRequest = {
                                accountId: accountId,
                                sessionContext: event.data.sessionContext,
                                browserData: event.data.browserData,
                                requestId: requestId
                            }
                            const vres = await VisaService.visaInit(vreq);
                            console.log("session created : ", vres);
                            if (vtsFrameRef) {
                                console.log("send auth session:  ")
                                const passkeyRequest = {
                                    requestID: event.data.requestID,
                                    type: "AUTHENTICATE",
                                    version: "1",
                                    contentType: "application/json",
                                    authenticationContext: vres.authenticationContext
                                }
                                vtsFrameRef.current?.contentWindow?.postMessage(JSON.stringify(passkeyRequest), vtsFidoUrl);
                            }
                        } else if (event.data.type === "AUTH_COMPLETE") {
                            console.log("auth_complete");
                            // pass assurance data
                            const vreq: VPurchaseRequest = {
                                accountId: accountId,
                                deviceId: deviceId,
                                assuranceData: {
                                    fidoBlob: event.data.assuranceData.fidoBlob,
                                    identifier: event.data.assuranceData.identifier
                                },
                                dfpSessionId: dfpSessionId,
                                amount: "9.99",
                                currencyCode: "USD",
                                mandateId: "mandate2342",
                                description: "test visa purchase",
                                requestId: requestId
                            }
                            const vres = await VisaService.purchase(vreq);
                            console.log("purhcase result: ", vres)

                        }
                    } catch (error) {
                        // log error?
                        console.log("error :", error, event.data);
                    }
                }
            },
            false,
        );

    }, [])
    const vtsFrameRef = useRef<HTMLIFrameElement>(null);
    const vtsApiKey = process.env.REACT_APP_VTS_APIKEY || "09O5WEOB1BMFYBPVFU4Y21eKLoV_i-tPpLOM0Frmk9HHA_rD8";
    const vtsClientId = process.env.REACT_APP_VTS_APIKEY || "VICTestAccountTR";
    const vtsFidoUrl = process.env.REACT_APP_VTS_FIDO_URL || "https://sbx.vts.auth.visa.com";
    const [authnUrl, setAuthnUrl] = useState<string>(`${vtsFidoUrl}/vts-auth/authenticate?apiKey=${vtsApiKey}&clientAppID=${vtsClientId}`);
    const [beginAuth, setBeginAuth] = useState(false);
    const [frame, setFrame] = useState<HTMLIFrameElement | null>(null);
    const [showAuth, setShowAuth] = useState<boolean>(false);
    const [deviceId, setDeviceId] = useState("vdevicetest7");
    const [accountId, setAccountId] = useState("vtesttoken7");
    const [pan, setPan] = useState("");
    const [panMonth, setPanMonth] = useState("12");
    const [panYear, setPanYear] = useState("2027");
    const [panCvv, setPanCvv] = useState("");

    async function initPurchase() {
        /*
        const height = 700;
        const SWIDTH = 520;
        let width = window.innerWidth;
        if (width > SWIDTH) {
            width = SWIDTH;
        }
        let largeScreen = true;
        if (window.innerWidth < 600) {
            largeScreen = false;
        }
        //var link = this.baseURL + "/checkout";
        var link = `${vtsFidoUrl}/vts-auth/authenticate?apiKey=${vtsApiKey}&clientAppID=${vtsClientId}`;

        var main = document.createElement("div");

        var background = document.createElement("div");
        background.style.display = "block";
        background.style.position = "fixed";
        //background.style.backgroundColor = "#cccccc00";
        background.style.top = "0";
        background.style.left = "0";
        background.style.width = "100%";
        background.style.height = "100%";
        main.style.zIndex = "9997";

        main.style.display = "block";
        main.style.border = "none";
        main.style.position = "fixed";
        main.style.zIndex = "9998";
        //main.style.backgroundColor = "#fff";
        //main.style.right = "0";
        if (largeScreen) {
            main.style.left = "" + (window.innerWidth / 2 - width / 2) + "px";
            main.style.top = "" + (window.innerHeight / 2 - (height + 32) / 2) + "px";
        } else {
            main.style.left = "" + (window.innerWidth / 2 - width / 2) + "px";
            main.style.top = "" + (window.innerHeight - (height + 32)) + "px";
        }
        main.style.boxShadow = "0 4px 8px 0 rgba(0,0,0,0.2)";
        main.style.width = "" + width + "px";

        var iframe = document.createElement("iframe");
        iframe.style.border = "none";
        iframe.style.position = "relative";
        //iframe.width = "320px";
        iframe.width = "" + width + "px";
        iframe.height = "" + height + "px";
        //iframe.height = "420px";
        iframe.id = "loginid-auth";
        iframe.allow = "publickey-credentials-get *; publickey-credentials-create * ;";

        iframe.setAttribute("src", link);
        setFrame(iframe);
        
        //  main.appendChild(image);
        //  main.appendChild(close);
        main.appendChild(iframe);

        document.body.appendChild(background);
        background.appendChild(main);
        console.log("add background");
        if (!largeScreen) {
            main.animate([{ transform: "translateY(100%)" }, { transform: "translateY(0)" }], { duration: 500 });
        }
            */
        //setShowAuth(true);

        let requestId = window.crypto.randomUUID()
        const vreq: VPurchaseRequest = {
            accountId: accountId,
            deviceId: deviceId,
            assuranceData: {
                fidoBlob: "passkey exempt",
                identifier: "abc123"
            },
            dfpSessionId: "dfpSession123",
            amount: "9.99",
            currencyCode: "USD",
            mandateId: "mandate2342",
            description: "test visa purchase",
            requestId: requestId
        }
        const vres = await VisaService.purchase(vreq);
        console.log("purhcase result: ", vres)
    }
    function closeFrame() {
        setShowAuth(false);
    }

    async function enrollPan() {
        const request: VPanEnroll = {
            deviceId: deviceId,
            accountId: accountId,
            accountNumber: pan,
            panMonth: panMonth,
            panYear: panYear,
            cvv: panCvv
        }
        const result = await VisaService.visaEnroll(request)
        console.log(result)
    }

    return (
        <>
            <Grid m={8}>
                <Grid.Col span={6}>
                    <Input.Wrapper label="AccountID">
                        <Input value={accountId} onChange={(e) => setAccountId(e.target.value)}></Input>
                    </Input.Wrapper>
                </Grid.Col>
                <Grid.Col span={6}>
                    <Input.Wrapper label="DeviceID">
                        <Input value={deviceId} onChange={(e) => setDeviceId(e.target.value)}></Input>
                    </Input.Wrapper>
                </Grid.Col>
                <Grid.Col span={6}>
                    <Input.Wrapper label="PAN">
                        <Input value={pan} onChange={(e) => setPan(e.target.value)}></Input>
                    </Input.Wrapper>
                </Grid.Col>

                <Grid.Col span={2}>
                    <Input.Wrapper label="month">
                        <Input placeholder="MM" value={panMonth} onChange={(e) => setPanMonth(e.target.value)}></Input>
                    </Input.Wrapper>
                </Grid.Col>
                <Grid.Col span={2}>
                    <Input.Wrapper label="year">
                        <Input placeholder="YYYY" value={panYear} onChange={(e) => setPanYear(e.target.value)}></Input>
                    </Input.Wrapper>
                </Grid.Col>
                <Grid.Col span={2}>
                    <Input.Wrapper label="cvv">
                        <Input placeholder="" value={panCvv} onChange={(e) => setPanCvv(e.target.value)}></Input>
                    </Input.Wrapper>

                </Grid.Col>
            </Grid>

            <Button onClick={enrollPan}>Enroll</Button>
            <Button onClick={initPurchase}>Start Purchase</Button>
            <Button onClick={closeFrame}>Close Frame</Button>
            {showAuth &&
                <iframe ref={vtsFrameRef} src={authnUrl} width="400" height="600" style={{ height: "600" }} allow="publickey-credentials-get *; publickey-credentials-create * ;"></iframe>
            }
        </>
    );
}